// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--c163e";
export var mainBtn = "main-module--main-btn--68785";
export var mainBtnSmall = "main-module--main-btn-small--af0a9";
export var mark = "main-module--mark--3c967";
export var markPurple = "main-module--mark--purple--f313e";
export var text = "main-module--text--eec1a";
export var title_h1 = "main-module--title_h1--2e77b";
export var title_h2 = "main-module--title_h2--5393c";
export var title_h3 = "main-module--title_h3--f73ac";
export var title_h4 = "main-module--title_h4--fb0e8";